import { Space, Typography, DatePicker, Checkbox, Button, Badge } from 'antd';
import { DownloadOutlined, SyncOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useDashboardKpis } from '../hooks/useDashboardQueries';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

export const DashboardHeader = ({
    dateRange,
    setDateRange,
    isComparing,
    setIsComparing,
    compareDateRange,
    setCompareDateRange,
    handleDownloadReport
}: any) => {
    const params = {
        startDate: dateRange?.[0]?.format('YYYY-MM-DD'),
        endDate: dateRange?.[1]?.format('YYYY-MM-DD'),
        timezone: 'Asia/Kolkata',
    };

    const { data: response, isLoading } = useDashboardKpis(params);

    const renderFreshness = () => {
        if (isLoading) return <Text type="secondary" style={{ fontSize: 12 }}><SyncOutlined spin /> Updating...</Text>;
        if (!response?.meta?.dataAsOf) return null;

        const { dataAsOf, reportingStatus } = response.meta;
        const timeAgo = dayjs().diff(dayjs(dataAsOf), 'minute');
        const text = timeAgo === 0 ? 'Data updated just now' : `Data updated ${timeAgo} minute${timeAgo === 1 ? '' : 's'} ago`;
        
        let statusColor = 'green';
        if (reportingStatus === 'STALE') statusColor = 'orange';
        if (reportingStatus === 'DEGRADED') statusColor = 'red';

        return (
            <Space size="small">
                <Badge color={statusColor} />
                <Text type="secondary" style={{ fontSize: 12 }}>{text}</Text>
            </Space>
        );
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
                <Title level={4} style={{ margin: 0 }}>Dashboard <Text type="secondary" style={{ fontSize: 14, fontWeight: 'normal', marginLeft: 8 }}>Overview of platform financials and billing activities</Text></Title>
                <div style={{ marginTop: 4 }}>
                    {renderFreshness()}
                </div>
            </div>
            <Space>
                <RangePicker value={dateRange} onChange={(dates) => setDateRange(dates)} placeholder={['Start Date', 'End Date']} />
                <Checkbox checked={isComparing} onChange={(e) => setIsComparing(e.target.checked)}>Compare</Checkbox>
                {isComparing && <RangePicker value={compareDateRange} onChange={(dates) => setCompareDateRange(dates)} disabledDate={(current) => current && current > dayjs().endOf('day')} placeholder={['Compare Start', 'Compare End']} />}
                <Button type="primary" icon={<DownloadOutlined />} onClick={handleDownloadReport}>Download Report</Button>
            </Space>
        </div>
    );
};
